/** Typed wrapper over the flow-catalog endpoint. */
import type { PortalFlow } from '@portal/contracts'
import { apiFetch } from './portal-client'

/** The flows this contractor may launch (enabled + disabled, with hints). */
export function listFlows(): Promise<PortalFlow[]> {
  return apiFetch<PortalFlow[]>('/api/flows')
}
